import { ca } from '@cian/analytics';

export function trackCreditFullPriceClick(isBankMortgage: boolean) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Card',
    action: 'click_info',
    label: 'open_loan_full_price_info',
    useLastProducts: true,
    page: {
      extra: {
        source: 'promo_listing',
        is_bank_mortgage: isBankMortgage,
      },
    },
  });
}

export function trackCianMortgageLinkClick(isBankMortgage: boolean) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Card',
    action: 'click_sopr',
    label: 'bank_mortgage_send_app',
    page: {
      extra: {
        is_bank_mortgage: isBankMortgage,
        source: 'promo_listing',
      },
    },
  });
}
